module.exports = __webpack_public_path__ + "img/default_avatar.76d778a0.png";